import { useLDClient } from 'launchdarkly-react-client-sdk';
import { CROWDIN_TRANSLATOR_FLAG } from '@/utils/constants';

/**
 * Returns `true` when approved Crowdin catalogs should be loaded.
 * When `false`, `FormattedMessage` renders English `defaultMessage`.
 */
const useTranslations = (): boolean => {
  const ldClient = useLDClient();
  return ldClient?.variation(CROWDIN_TRANSLATOR_FLAG, false) ?? false;
};

export default useTranslations;
